const API_URL = (process.env.REACT_APP_API_URL || window.location.origin).replace(/\/+$/, '');

export default API_URL;
